import { Navigate } from 'react-router';

// Guards
import AuthGuard from './components/guards/authGuard';
// import RolesGuard from './components/guards/rolesGuard';
import DashboardLayout from './components/layout/DashboardLayout';

import Auth from './pages/auth/auth';

// Typescript routes
import AddUpdateEventPage from '@pages/Events/AddUpdateEventPage';
import Dashboard from './pages/Dashboard/dashboard';
import Events from './pages/Events/PublicEvents';
import EventDetail from '@pages/Events/EventDetail';
import EventProvider from '@providers/EventProvider';
import MyRegisteredEvents from '@pages/Events/MyRegisteredEvents';
import ManageEvents from './pages/Events/ManageEvents';
import WrestlerDetail from '@pages/Wrestlers/WrestlerDetail';
import TeamDetails from './pages/Teams/TeamDetails';
import Page404 from './pages/auth/page404';
import PaymentFail from './pages/Payment/PaymentFail';
import PaymentSuccess from './pages/Payment/PaymentSuccess';
import RegisterWrestler from './pages/Wrestlers/RegisterWrestler';
import MyEarnings from './pages/MyEarnings/MyEarnings';

const routes = [
    {
        path: '/',
        element: <Navigate to="/events" replace={true} />,
        exact: true,
    },
    {
        path: 'events-public',
        element: (
            <EventProvider>
                <DashboardLayout />
            </EventProvider>
        ),
        children: [
            {
                path: '',
                element: <Events />,
            },
            {
                path: 'new',
                element: <AddUpdateEventPage />,
            },
            {
                path: ':eventId',
                element: (
                    <EventProvider>
                        <EventDetail />
                    </EventProvider>
                ),
            },
        ],
    },
    {
        path: 'dashboard',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={STUDENT}> */}
                <DashboardLayout />
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: <Dashboard />,
            },
        ],
    },
    {
        path: 'teams/:teamId',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={SUPER_COACH}> */}
                <DashboardLayout />
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: <TeamDetails />,
            },
        ],
    },
    {
        path: 'earning',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={ALL}> */}
                <DashboardLayout />
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: <MyEarnings />,
            },
        ],
    },
    {
        path: 'events',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={ALL}> */}
                <EventProvider>
                    <DashboardLayout />
                </EventProvider>
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: <Events />,
            },
            {
                path: ':eventId',
                element: (
                    <EventProvider>
                        <EventDetail />
                    </EventProvider>
                ),
            },
        ],
    },
    {
        path: 'manage-events',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={ALL}> */}
                <EventProvider>
                    <DashboardLayout />
                </EventProvider>
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: <ManageEvents />,
            },
        ],
    },
    {
        path: 'registered-events',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={ALL}> */}
                <EventProvider>
                    <DashboardLayout />
                </EventProvider>
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: <MyRegisteredEvents />,
            },
        ],
    },
    {
        path: 'athletes',
        element: (
            <AuthGuard>
                {/* <RolesGuard roles={[...COACH, ...SUPER_COACH]}> */}
                <DashboardLayout />
                {/* </RolesGuard> */}
            </AuthGuard>
        ),
        children: [
            {
                path: ':athleteId',
                element: <WrestlerDetail />,
            },
        ],
    },
    {
        path: '',
        children: [
            {
                path: '/auth',
                element: <Auth />,
            },
            {
                path: '/register-wrestler/:id',
                element: <RegisterWrestler />,
            },
        ],
    },
    {
        path: '/payment/success',
        element: <PaymentSuccess />,
    },
    {
        path: '/payment/cancel',
        element: <PaymentFail />,
    },
    {
        path: '*',
        children: [
            {
                path: '*',
                element: <Page404 />,
            },
        ],
    },
];

export default routes;
